module.exports = __webpack_public_path__ + "static/media/demo-13.308a7fcf.jpg";